import { isSuccess } from '@devexperts/remote-data-ts'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { cartSlice } from '@/store/cartSlice'
import { RootState } from '@/store/configureStore.ts'

export const cartResetInsertInsuranceServices = createAsyncThunk<void>(
  'cart/cartResetInsertInsuranceServices',
  async (_, thunkAPI) => {
    const state = thunkAPI.getState() as RootState

    if (state.cart.cartReservations.length === 0) {
      return
    }

    const featuredExtraServices = isSuccess(state.services.services)
      ? state.services.services.value.extraFeaturedServices
      : []

    if (featuredExtraServices.length === 0) {
      return
    }

    const featuredServicesIds = featuredExtraServices.map(
      (item) => item.serviceId
    )

    const updatedCartReservations = state.cart.cartReservations.map(
      (reservation) => {
        const filteredBoughtServices = { ...reservation.boughtServices }
        featuredServicesIds.forEach((serviceId) => {
          if (serviceId in filteredBoughtServices) {
            delete filteredBoughtServices[serviceId]
          }
        })

        return {
          ...reservation,
          boughtServices: filteredBoughtServices,
        }
      }
    )

    thunkAPI.dispatch(
      cartSlice.actions.setCartReservations(updatedCartReservations)
    )
  }
)
